import p5 from 'p5';

class ParticleSystems {
	constructor(p, x, y, firework) {
		this.p = p;
		this.firework = firework;
		this.lifeSpan = p.random(100, 200);
		this.vel = p5.Vector.random2D();
		this.pos = p.createVector(x, y);
		this.r = p.random(3, 7);
		if (firework) {
			this.gravity = p.createVector(0, 0);
			this.shape = 0;
			this.lifeSpan = p.random(100, 200);
		} else {
			this.vel.mult(p.random(3, 10));
			this.gravity = p.createVector(0, 0.2);
			//this.r = p.random(2, 10);
			this.shape = p.floor(p.random(3, 7));
			this.lifeSpan = 100;
		}
		this.acc = p.createVector(0, 0);
	}

	applyForce() {
		this.acc.add(this.gravity);
	}

	update() {
		if (!this.firework) {
			this.vel.mult(0.85);
			this.lifeSpan += 1;
		} else {
			this.lifeSpan += 0.05;
			if (this.lifeSpan > 255) {
				this.pos = this.p.createVector(
					this.p.width + this.p.random(20),
					this.p.height + this.p.random(20)
				);
				this.lifeSpan = this.p.random(100, 200);
			}
		}
		this.vel.add(this.acc);
		this.pos.add(this.vel);
		this.acc.mult(0);
	}

	edges() {
		if (this.pos.x > this.p.width) this.pos.x = 0;
		if (this.pos.x < 0) this.pos.x = this.p.width;
		if (this.pos.y > this.p.height) this.pos.y = 0;
		if (this.pos.y < 0) this.pos.y = this.p.height;
	}

	show() {
		this.p.stroke(this.lifeSpan);
		if (!this.firework) {
			//this.p.strokeWeight(10);
			//this.p.stroke(0, this.lifeSpan);

			this.p.push();
			this.p.translate(this.pos.x, this.pos.y);
			this.p.beginShape();
			for (let i = 0; i < this.shape; i++) {
				//console.log('shape');
				let angle = this.p.map(i, 0, this.shape, 0, this.p.TWO_PI);
				let x = this.r * this.p.cos(angle);
				let y = this.r * this.p.sin(angle);
				this.p.vertex(x, y);
			}
			this.p.endShape(this.p.CLOSE);
			this.p.pop();
		} else {
			this.edges();
			//this.p.strokeWeight(20);
			//this.p.stroke(0);
			this.p.ellipse(this.pos.x, this.pos.y, this.r * 2, this.r * 2);
		}
	}

	isDone() {
		if (this.lifeSpan > 255) {
			return true;
		} else {
			return false;
		}
	}
}

export default ParticleSystems;
